import { UserCheck } from "lucide-react";

const AlertSection = ({ alert }: { alert: string }) => {
  const isAlert = alert && alert.toLowerCase() !== "none";
  const color = isAlert ? "red" : "green";
  const content = isAlert ? alert : "No alerts, all good!";

  return (
    <div className={`p-4 bg-${color}-50 border border-${color}-900 rounded-lg`}>
      <div className="flex items-center mb-2">
        <UserCheck className={`w-4 h-4 text-${color}-600 mr-2`} />
        <h3 className={`font-medium text-${color}-900`}>Alerts</h3>
      </div>
      <p className={`text-sm text-${color}-800`}>{content}</p>
    </div>
  );
};

export default AlertSection;
